import { getMCPMonitorChannelCount } from "@/api/endpoints/searches";
import { useI18n } from "@/contexts/i18nContext";
import { SearchFilterV4WithDates } from "@/types/SearchFilter";
import {
  Widget,
  WidgetHeader,
  WidgetProps,
  WidgetStat,
  WidgetTitle,
} from "@components/ui/widget";
import { getMCPMonitorFiltersFromSearchFilterV4 } from "@components/widgets/utils";
import { Trans } from "@lingui/react/macro";
import { useQuery } from "@tanstack/react-query";

export default function ChannelCountWidget({
  searchUuid,
  filters,
  ...rest
}: WidgetProps & {
  searchUuid: Uuid;
  filters: SearchFilterV4WithDates;
}) {
  const { abbreviateNumber } = useI18n();

  // Server state
  const { data, isLoading } = useQuery({
    queryKey: [searchUuid, "insights-results", "total-channels", filters],
    queryFn: async () => {
      return getMCPMonitorChannelCount(
        searchUuid,
        getMCPMonitorFiltersFromSearchFilterV4(filters)
      );
    },
  });

  return (
    <Widget {...rest}>
      <WidgetHeader isLoading={isLoading}>
        <WidgetTitle>
          <Trans>Unika källor</Trans>
        </WidgetTitle>

        {data?.ok ? (
          <WidgetStat>{abbreviateNumber(data.data.channel_count)}</WidgetStat>
        ) : null}
      </WidgetHeader>
    </Widget>
  );
}
